export default "__VITE_ASSET__11e7d1ad__"